import { IFormValues } from '../types';

const getInitialValues = (): IFormValues => ({
  items: [],
});

export default getInitialValues;
